import { useEffect, useState } from 'react'
import styles from './MidtermGoftinoButton.module.scss'
import Icon from '@/components/UI/icon/Icon'
import TooltipGoftino from './tooltipGoftino/TooltipGoftino'
import Box from '@/components/UI/box/Box'
interface MidtermGoftinoButton {
  showDownloadBanner: boolean
  onToggle: () => void
}

const MidtermGoftinoButton = ({
  showDownloadBanner,
  onToggle,
}: MidtermGoftinoButton) => {
  const [isDownloadBanner, setIsDownloadBanner] = useState(false)
  useEffect(() => {
    if (sessionStorage.getItem('show-download-banner')) {
      setIsDownloadBanner(false)
    } else {
      setIsDownloadBanner(true)
    }
  }, [showDownloadBanner])

  return (
    <>
      <Box
        className={`${styles['button']} ${isDownloadBanner ? styles['has-banner'] : ''}`}
        onClick={onToggle}
      >
        <Icon size={'xLarge'} name={'message'} type={'white'} />
        <TooltipGoftino text="مشاوره رایگان" />
      </Box>
    </>
  )
}

export default MidtermGoftinoButton
